module.exports = __webpack_public_path__ + "img/1.2c097691.png";